import {
    GETNOTIFICATIONCONFIGPARTNER_SUCCESS,
    GETNOTIFICATIONCONFIGPARTNER_FAILED,
    RESET_GETNOTIFICATIONCONFIGPARTNER,
    // LOADING_GETNOTIFICATIONCONFIGPARTNER,
    NETWORK_ERROR_GETNOTIFICATIONCONFIGPARTNER,
} from "../types/index";
import { partnerServices } from "../../config/axios";


const resetGetNotificationConfigList = () => {
    return { type: RESET_GETNOTIFICATIONCONFIGPARTNER };
};

const getNotificationConfigsList = (userData, authTokenIs) => async (dispatch) => {
    // dispatch({ type: LOADING_GETNOTIFICATIONCONFIGPARTNER });
    await partnerServices
        .post("getNotificationConfig", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "Success":
                    dispatch(getNotificationConfigsuccess(res.data));
                    break;
                case "success":
                    dispatch(getNotificationConfigsuccess(res.data));
                    break;
                default:
                    dispatch(getNotificationConfigFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({ type: NETWORK_ERROR_GETNOTIFICATIONCONFIGPARTNER, payload: err });
        });
};
function getNotificationConfigsuccess(data) {
    return {
        type: GETNOTIFICATIONCONFIGPARTNER_SUCCESS,
        payload: data,
    };
}
function getNotificationConfigFailed(data) {
    return {
        type: GETNOTIFICATIONCONFIGPARTNER_FAILED,
        payload: data,
    };
}

export { resetGetNotificationConfigList, getNotificationConfigsList };
